import styled from 'styled-components'

export const Container = styled.div`
  padding: 1.5rem 1.25rem 0;
  height: calc(100vh - 70px);
  overflow: auto;
`
